<template>
    <div>
        <div class="title">{{ $t("morder.infoTitle") }}</div>
        <div class="mline"></div>
        <div style="margin-top:20px">
            <div v-for="(user,index) in userConfig" style="margin-bottom:10px;width:400px;float:left">
                <label style="display:inline-block;width:200px;text-align:right">{{user.cfgName}}:</label>
                <label>{{user.cfgValue!=null && user.cfgValue.length>15?user.cfgValue.substr(0,15)+"...":user.cfgValue}}</label>
            </div>
        </div>
        <div class="title" style="padding-top:30px">
            <span>{{ $t("morder.signTitle") }}</span>
        </div>
        <div class="mline"></div>
        <div>
            <div class="o_label">
                <label>{{ $t("morder.signType") }}:</label>
                <label>{{feeName}}</label>
            </div>
            <div class="pay" :class="{pay_mg_en:locale=='en',pay_mg_ch:locale=='ch'}">
                <p>
                    <span>{{ $t("morder.payType") }}:</span>
                    <span>{{register.regPayway=='1'?$t("pay.payOnline"):$t("pay.payOffline")}}</span>
                </p>
                <p>
                    <span>{{ $t("morder.payStatus") }}:</span>
                    <span style="color:red">{{register.regFl=='0'||register.regFl=='1'?$t("pay.nopay"):register.regFl=='2'?$t("pay.payed"):register.regFl=='4'?$t("pay.drawback") :register.regFl=='5'?$t("pay.drawbacked"):""}}</span>
                </p>
                <p>
                    <span>{{ $t("morder.regMoneyTitle") }}:</span>
                    <span style="color:red">{{register.regMoney}}{{locale=='en'?"CNY":"元"}}</span>
                </p>
            </div>
        </div>
        <div class="title" style="padding-top:30px">
            <span>{{ $t("morder.hotelTitle") }}</span>
        </div>
        <div class="mline"></div>
        <div v-show="bookId==''||bookId==null" style="margin-left:30px;margin-top:20px;font-size:16px">{{ $t("morder.noHotel") }}</div>
        <div v-for="hotelBook in hotel_books">
            <div class="o_label">
                <label>{{ $t("morder.hotelName") }}:</label>
                <label>{{hotelBook.hotel.hName}}</label>
            </div>
            <div class="o_label">
                <label>{{ $t("morder.roomType") }}:</label>
                <label>{{hotelBook.room.rmName}}</label>
                <label style="margin-left: 30px">{{ $t("hotel.inHotelTime") }}:</label>
                <label>{{hotelBook.bookStartDt|formatDt}}</label>
                <label style="margin-left: 30px">{{ $t("hotel.outHotelTime") }}:</label>
                <label>{{hotelBook.bookEndDt|formatDt}}</label>
            </div>
            <div class="o_label">
                <label>{{ $t("hotel.days") }}:</label>
                <label>{{hotelBook.bookDays}}{{$t("morder.night")}}</label>
                <label style="margin-left: 30px" v-show="hotelBook.bookRoomieName!=''&& hotelBook.bookRoomieName!=null">{{ $t("hotel.togeName") }}:</label>
                <label v-show="hotelBook.bookRoomieName!='' && hotelBook.bookRoomieName!=null">{{hotelBook.bookRoomieName}}</label>
                <label style="margin-left: 30px" v-show="hotelBook.bookRoomiePhone!=''&& hotelBook.bookRoomiePhone!=null">{{ $t("hotel.togePhone") }}:</label>
                <label v-show="hotelBook.bookRoomiePhone!='' && hotelBook.bookRoomiePhone!=null">{{hotelBook.bookRoomiePhone}}</label>
            </div>
            <div class="pay" :class="{pay_mg_en:locale=='en',pay_mg_ch:locale=='ch'}">
                <p>
                    <span>{{ $t("morder.payType") }}:</span>
                    <span>{{hotelBook.bookPayway=='1'?$t("pay.payOnline"):$t("pay.payOffline")}}</span>
                </p>
                <p>
                    <span>{{ $t("morder.payStatus") }}:</span>
                    <span style="color:red">{{hotelBook.bookFl=='0'||hotelBook.bookFl=='1'?$t("pay.nopay"):hotelBook.bookFl=='2'?$t("pay.payed"):""}}</span>
                </p>
                <p>
                    <span>{{ $t("hotel.hotelMoney") }}:</span>
                    <span style="color:red">{{hotelBook.bookMoney}}{{locale=='en'?"CNY":"元"}}</span>
                </p>
            </div>
        </div>
        <div class="title" style="margin-top:30px" v-show="regConfig.cfgInvoiceFl=='1' && locale=='ch'">
            <span>{{ $t("morder.invTitle") }}</span>
        </div>
        <div class="mline" v-show="regConfig.cfgInvoiceFl=='1' && locale=='ch'"></div>
        <div v-show="register.regInvoiceType=='0'" style="margin-left:30px;margin-top:20px;font-size:16px">{{ $t("morder.noInvoice") }}</div>
        <div v-show="regConfig.cfgInvoiceFl=='1' && register.regInvoiceType!='0' && locale=='ch'">
            <div class="o_label">
                <label :class="{vtype_mg_en:locale=='en'}">{{ $t("morder.invoiceType") }}:</label>
                <label>{{register.regInvoiceType=='1'?$t("invoice.invoiceType1"):$t("invoice.invoiceType2")}}</label>
            </div>
            <div class="o_label" v-show="register.regInvoiceType=='1'">
                <label :class="{vtype1_mg_en:locale=='en'}">{{ $t("invoice.invRegTitle") }}:</label>
                <label>{{register.regInvTitle}}</label>
            </div>
            <div v-show="register.regInvoiceType=='2'" :class="{vad_mg_en:locale=='en'}">
                <div class="o_label">
                    <label :class="{o_label_en:locale=='en'}">{{ $t("invoice.invAddOrg") }}:</label>
                    <label>{{register.regInvOrg}}</label>
                </div>
                <div style="margin-left:-6px;margin-top:10px">
                    <label :class="{o_label_en2:locale=='en'}">{{ $t("invoice.invAddTax") }}:</label>
                    <label>{{register.regInvTax}}</label>
                </div>
                <div class="o_label">
                    <label :class="{o_label_en:locale=='en'}">{{ $t("invoice.invAddAddr") }}:</label>
                    <label>{{register.regInvAddr}}</label>
                </div>
                <div class="o_label">
                    <label :class="{o_label_en:locale=='en'}">{{ $t("invoice.invAddTel") }}:</label>
                    <label>{{register.regInvTel}}</label>
                </div>
                <div class="o_label">
                    <label :class="{o_label_en:locale=='en'}">{{ $t("invoice.invAddBank") }}:</label>
                    <label>{{register.regInvBank}}</label>
                </div>
                <div class="o_label">
                    <label :class="{o_label_en:locale=='en'}">{{ $t("invoice.invAddAcount") }}:</label>
                    <label>{{register.regInvAccount}}</label>
                </div>
            </div>
            <div v-if="register.regInvoiceType!='0'">
                <div :class="{ch_mg_contact:locale=='ch',en_mg_contact2:locale=='en'}">
                    <label>{{ $t("invoice.invGetName") }}:</label>
                    <label>{{register.regInvoiceContact}}</label>
                </div>
                <div :class="{ch_mg_contact:locale=='ch',en_mg_contact:locale=='en'}">
                    <label>{{ $t("invoice.invGetPhone") }}:</label>
                    <label>{{register.regInvoicePhone}}</label>
                </div>
                <div :class="{ch_mg_contact2:locale=='ch',en_mg_contact:locale=='en'}">
                    <label>{{ $t("invoice.invGetAddr") }}:</label>
                    <label>{{register.regInvoiceAddr}}</label>
                </div>
            </div>
        </div>
        <div style="margin:30px 30px;" v-html="regConfig.cfgConfirmDesc"></div>
        <div style="margin-top:80px;text-align:center">
            <button class="btn" @click="pre">{{ $t("btn.pre") }}</button>
            <button class="btn" @click="next" style="background-color:#F39800;color:#FFF">{{ $t("pay.payOrder") }}</button>
        </div>
    </div>
</template>
<script>
export default {
    data() {
            return {
                invoice: {},
                feeName: '', //报名类型
                hotel_books: [],
                register: {},
                conFee: {},
                regConfig: {},
                userConfig: [],
                refundFlag: true,
                previewSrc: '',
                hasImg: true,
                uid: '',
                cid: '',
                regId: '',
                bookId: '',
                btnShow: false,
                locale: ''
            }
        },
        mounted() {
            this.locale = localStorage.getItem("locale");
            let userStore = JSON.parse(localStorage.getItem('user'));
            // this.invoice = JSON.parse(sessionStorage.getItem('invoice'));
            this.uid = userStore.uId;
            this.cid = Number(localStorage.getItem('cid').trim());
            this.regId = JSON.parse(sessionStorage.getItem('payInfo')).data.register.regId;
            this.bookId = sessionStorage.getItem('hotelBook') != null ? JSON.parse(sessionStorage.getItem('hotelBook')).bookId : '';
            let param = {
                "uid": this.uid,
                "cid": this.cid
            }
            this.postHttp('/medapp/api/template/register/info', param).then((result) => {
                this.hotel_books = result.data.hotel_book;
                this.register = result.data.register;
                this.conFee = result.data.con_fee;
                this.regConfig = result.data.reg_config;
                this.userConfig = result.data.user_config;
                if (new Date().getTime() > this.regConfig.cfgRefundEnd) { //如果当前大于退款截至时间  则不能退款
                    this.refundFlag = false;
                }
                this.setFeeName();

                //判断立即付款按钮是否显示
                if (this.register.regPayway == '1' && (this.register.regFl == '0' || this.register.regFl == '1')) {
                    this.btnShow = true;
                }
                for (let i = 0; i < this.hotel_books.length; i++) {
                    if (this.hotel_books[i].bookPayway == '1' && (this.hotel_books[i].bookFl == '0' || this.hotel_books[i].bookFl == '1')) {
                        this.btnShow = true;
                        break;
                    }
                }

                sessionStorage.setItem("invoice", JSON.stringify(this.register));
            });

        },
        methods: {
            setFeeName: function() {
                for (let i = 0; i < this.conFee.length; i++) {
                    if (this.conFee[i].feeId == this.register.regFeeid) {
                        this.feeName = this.conFee[i].feeName;
                        break;
                    }
                }
            },
            pre: function() {
                if(this.locale=="ch"){
                    this.$router.push("/sign/invoice/0")
                }else{
                    this.$router.push("/sign/hotel/0")
                }

            },
            next: function() {
                let param2 = {
                    bookid: this.bookId,
                    book_status: '1', // 1酒店提交
                };
                let param1 = {
                    regid: this.regId,
                    reg_status: '1', // 1:报名提交
                };
                 param1.cfgid = localStorage.getItem('sourceId')||'';
                //把注册订单和酒店订单状态更新成1
                this.postHttp('/medapp/api/template/register/add', param1).then((result) => {
                    if (result.data.code == '0') {
                        this.postHttp('/medapp/api/template/register/hotel/add', param2).then((result) => {
                            if (this.btnShow) {
                                this.$router.push("/sign/pay");
                            } else {
                                this.$router.push("/order/info");
                            }

                        });
                    }
                });

            }
        },
        computed: {
            bdPreview() {
                let src = this.previewSrc;
                if (!src) return '';
                this.hasImg = false;
                return {
                    'background-image': 'url(' + src + ')'
                }
            }
        },
        filters: {
            formatDt: function(dtVal) {
                return new Date(dtVal).Format("yyyy-MM-dd");
            }
        }
}
</script>
<style scoped>
.preview {
    width: 100%;
    height: 100%;
    z-index: 1;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
}

.file-box input#file {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
}

.ch_mg_contact {
    margin-left: 14px;
    margin-top: 10px
}

.en_mg_contact {
    margin-left: -10px;
    margin-top: 10px
}

.en_mg_contact2 {
    margin-left: 0px;
    margin-top: 10px
}

.ch_mg_contact2 {
    margin-left: 30px;
    margin-top: 10px
}

.pay_mg_en {
    margin-left: 600px;
}

.pay_mg_ch {
    margin-left: 700px;
}
.vad_mg_en{
    margin-left:-110px;
}
.vtype_mg_en{
    margin-left:-7px;
}
.vtype1_mg_en{
    margin-left:-4px;
}
.file-box {
    width: 400px;
    height: 250px;
    margin-left: 30px;
    margin-top: 10px;
    position: relative;
    background-repeat: no-repeat;
    background-color: #eee;
    background-position: center center;
    background-size: 100px 100px;
    background-image: url(./photo.png);
}

.title {
    font-size: 18px;
    color: #000;
    font-weight: 600;
    margin-top: 40px;
    clear: both;
}

.mline {
    height: 1px;
    width: 100%;
    background: #DCDCDC;
    margin-top: 5px;
}

.o_label {
    margin-left: 30px;
    margin-top: 10px
}
.o_label_en{
    display: inline-block;
    width:200px;
    text-align: right
}

.o_label_en2{
    display: inline-block;
    width:235px;
    text-align: right
}

.h_main {
    margin-top: 30px;
}

.ht_name_circle {
    width: 220px;
    height: 40px;
    border-radius: 30px;
    outline: none;
    border: 1px solid #cfcfcf;
    color: #000;
    background-color: #FFF;
    font-size: 16px;
    margin-right: 30px;
}

label {
    font-size: 16px;
    color: #000;
    font-weight: 500;
    margin-right: 10px;
}

.pay {
    margin-top: 20px;
}

.pay p {
    margin-top: 5px;
}

.pay span {
    font-size: 16px;
    color: #000;
    font-weight: 600;
}

.btn {
    width: 200px;
    height: 50px;
    border-radius: 30px;
    outline: none;
    border: 0;
    color: #FFF;
    background-color: #33D0C2;
    font-size: 18px;
    margin-right: 30px;
    cursor: pointer;
}

.foot {
    text-align: center;
    margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// morder.vue?2dfae9ae